import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { registerServiceWorker } from "./pwa";

const rootElement = document.getElementById("root");

// Prerendered crawler skeleton (scripts/prerender.js) is replaced by the live app.
rootElement.replaceChildren();
const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Register PWA Service Worker
registerServiceWorker();
